
















import Vue from "vue";
import store, { BankRemitStore } from "../services/BankRemitStore";
import BankRemitApi from "../services/BankRemitApi";
import PartBank, { partBankDefaultProps } from "../../cashPoint/models/PartBank";
import eventBus from "@/services/eventBus";

interface Data {
  store: BankRemitStore;
  partner: number;
  bankAccountNames: PartBank[];
}

interface Props {
  value: number;
  bankAccountName: string;
  disabled: boolean;
  bankAccount: number;
}

export default Vue.extend<Data, {}, {}, Props>({
  props: {
    value: { type: Number, default: 1 },
    bankAccountName: { type: String },
    disabled: { type: Boolean, default: false },
    bankAccount: { type: Number, default: 1 },
  },

  data() {
    return {
      store,
      partner: 1,
      bankAccountNames: [],
    };
  },

  async mounted() {
    //this.partner = { ...this.value };
    await BankRemitApi.getPartBanksByPartner(this.value).then((data) => (this.bankAccountNames = data));

    /*const p = { ...partBankDefaultProps };
    p.accountNo = this.bankAccountName;
    this.bankAccountNames.push(p);*/

    eventBus.$on(`bank-remit-update`, async () => {
      console.log(this.value);

      await BankRemitApi.getPartBanksByPartner(this.value).then((data) => (this.bankAccountNames = data));

      /*const p = { ...partBankDefaultProps };
      p.accountNo = this.bankAccountName;
      this.bankAccountNames.push(p);*/
    });
  },

  methods: {
    bankAccountChanged(e: any) {
      this.$emit("bankAccountChanged",{ accountNo: e.accountNo, ibanAccountNo: e.ibanNo, id: e.id });
    },
  },
});
